(function() {
  'use strict';

  /**
   * @author Dahang Xu
   * @description  Semafone PCI  Service
   * @class ute-ui
   * @memberOf ute-ui
   */

  angular.module('ute.ui').factory('uteSemafonePCIService', _service);

  _service.$inject = [];

  /* @ngInject */
  function _service() {
    var service = {
      getEncryptedCardNumber: getEncryptedCardNumber
    };

    return service;

    function getEncryptedCardNumber(encryptString) {
      return encryptString;
      if (validateToken(encryptString)) {
        return encryptString;
      }
      return '';
    }

    function validateToken(encryptString) {
      if (encryptString.charAt(0) == '0' && encryptString.charAt(1) == '2') {
        var hexString = encryptString.substring(4, 6) + encryptString.substring(2, 4);
        var decVal = parseInt(hexString, 16) + 12;
        if (encryptString.substr(encryptString.length - 2) == '03' && encryptString.length >= decVal) {
          return true;
        }
      }
      return false;
    }
  }
})();
